import { ObserveAttributes } from './agent';

export function minify(event: any) {
    return {
        eat: event.emittedAt,
        typ: event.type,
        vti: event.currentTime,
        pau: event.paused,
        eco: event.errorCode,
    };
}

export function postHttp(endpoint: string, hostname: string | undefined, events: any, attributes: ObserveAttributes) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', endpoint, true);
    if (hostname) xhr.setRequestHeader("x-performa-origin", hostname);
    xhr.setRequestHeader('Content-Type', 'application/json; charset= utf-8');

    xhr.send(
        JSON.stringify({
            pid: attributes.playbackId,
            fid: attributes.fileId,
            eve: events.map((event: any) => minify(event)),
        })
    );
}
